const { ont = {} } = window.utils;

export default {
  /**
   * 格式化timestamp
   * @param  timestamp
   * @param  {string} format    格式字符串, 如 yyyy-MM-dd, yyyy-MM-dd hh:mm:ss
   * @return {string}           格式化后的字符串
   */
  formatTimestamp(timestamp, format) {
    const inputDate = new Date(timestamp);
    const date = {
      'M+': inputDate.getMonth() + 1,
      'd+': inputDate.getDate(),
      'h+': inputDate.getHours(),
      'm+': inputDate.getMinutes(),
      's+': inputDate.getSeconds(),
      'q+': Math.floor((inputDate.getMonth() + 3) / 3),
      'S+': inputDate.getMilliseconds(),
    };
    let formatValue = '';
    if (/(y+)/i.test(format)) {
      formatValue = format.replace(
        RegExp.$1,
        inputDate
          .getFullYear()
          .toString()
          .substr(4 - RegExp.$1.length)
      );
    }
    Object.keys(date).forEach((k) => {
      if (new RegExp(`(${k})`).test(format)) {
        formatValue = formatValue.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? date[k]
            : `00${date[k]}`.substr(`${date[k]}`.length)
        );
      }
    });
    return formatValue;
  },

  /**
   * get url
   */
  urlStringify(urlMap) {
    if (!urlMap) {
      return '';
    }

    const str = [];

    Object.keys(urlMap).forEach((key) => {
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(urlMap[key])}`);
    });

    return str.join('&');
  },

  /**
   * 获取参数
   */
  getUrlParam(key) {
    const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`, 'i');
    const match = window.location.search.substr(1).match(reg);
    if (match) {
      return unescape(match[2]);
    }
    return null;
  },

  /**
   * 设置参数
   */
  setUrlParams(params) {
    const debug = this.getUrlParam('debug_push');
    const { origin, pathname } = window.location;
    const url = `${origin}${pathname}?${this.urlStringify(params)}`;
    window.history.replaceState(
      null,
      null,
      debug ? `${url}&debug_push=true` : url
    );
  },

  /**
   * 日期格式化
   */
  dateFormat(time, format = 'yyyy-MM-dd hh:mm:ss') {
    const date = new Date(time || new Date());
    // 补零
    const padNum = (num) => {
      return String(num).replace(/^(\d)$/, '0$1');
    };

    // 指定格式字符
    const cfg = {
      yyyy: date.getFullYear(), // 年 : 4位
      yy: date.getFullYear().toString().substring(2), // 年 : 2位
      M: date.getMonth() + 1, // 月 : 如果1位的时候不补0
      MM: padNum(date.getMonth() + 1), // 月 : 如果1位的时候补0
      d: date.getDate(), // 日 : 如果1位的时候不补0
      dd: padNum(date.getDate()), // 日 : 如果1位的时候补0
      hh: padNum(date.getHours()), // 时
      mm: padNum(date.getMinutes()), // 分
      ss: padNum(date.getSeconds()), // 秒
    };

    return format.replace(/([a-z])(\1)*/gi, (m) => {
      return cfg[m];
    });
  },

  /**
   * 日期转时间戳
   */
  transferTime(time) {
    const timer = time ? time.replace(/-/g, '/') : '';

    return new Date(timer).getTime();
  },
  transferTimeStamp(time) {
    return new Date(time).getTime();
  },
  /**
   * 日期 格式化
   * time 2019-09-09 22:22:22
   * => yyyy-mm-dd hh:mm:ss
   */
  transferTimeHM(time) {
    const timer = new Date(time).getTime();

    return this.dateFormat(timer, 'yyyy-MM-dd hh:mm');
  },

  transferTimeHMS(time) {
    const timer = new Date(time).getTime();

    return this.dateFormat(timer, 'yyyy-MM-dd hh:mm:ss');
  },

  /**
   * 参数验证
   * @param param 验证是否为空 0 undefined null 等
   */
  verifyParam(param) {
    const errParam = [0, null, undefined, ''];
    if (errParam.includes(param)) {
      return true;
    } else if (param <= 0) {
      return true;
    }

    return false;
  },
  getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  },
  getQueryProductString(name) {
    const reg = new RegExp(`(^|&)${name}=(\\w+[_|-]\\w+)(&|$)`, 'i');
    const r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  },
  getUrlParamString(name) {
    const res = this.getQueryProductString(name);
    if (res === null) {
      const { pathname } = window.location;
      const productReg = /spot.*\/(\w+[_|-]\w+)(\/?)/; // spot/btc_usdt spot/btc-usdt
      const matchResult = pathname.match(productReg);
      return matchResult ? matchResult[1] : '';
    }
    return res;
  },
  isLogin() {
    return ont?.isLogin();
  },
  // 函数防抖
  debounce(fn, delay = 200) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  },
  // 函数节流
  throttle(fn, delay = 200) {
    let timer = null;
    return (...args) => {
      if (!timer) {
        timer = setTimeout(() => {
          fn(...args);
          clearTimeout(timer);
          timer = null;
        }, delay);
      }
    };
  },
};

export const getErrorMsg = (error) => {
  return error?.msg || error?.data?.msg || error?.data?.error_message;
};
